import { memo } from 'react';
import { LoanService } from '../../services';
import { useError } from '../../contexts/ErrorContext';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MoneyOffIcon from '@material-ui/icons/MoneyOff';


const AddMarkAsNotFundingButton = ({selectedRowIndices, records}) => {
    const { showError } = useError();
    const loanNumbers = selectedRowIndices.map(rowId => records[rowId].loanNumber)
    const handleClick = () => {
        LoanService.markLoansAsNotFunding(loanNumbers).then(response => {
          // !FIXME: Do this better!
          window.location.reload();
        }).catch(showError);
    }

  return (
      <Tooltip title={`Mark as 'Not Funding'`}>
          <IconButton onClick={handleClick}>
              <MoneyOffIcon />
          </IconButton>
      </Tooltip>
  );
}

export default memo(AddMarkAsNotFundingButton);
